import { render, staticRenderFns } from "./popup-click-fields-picker.vue?vue&type=template&id=bd9b2e82"
import script from "./popup-click-fields-picker.vue?vue&type=script&lang=js"
export * from "./popup-click-fields-picker.vue?vue&type=script&lang=js"
import style0 from "./popup-click-fields-picker.vue?vue&type=style&index=0&id=bd9b2e82&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports